/**
 * Shared layout dimension constants.
 *
 * These values are referenced by Content, Navigation, and FormTabBarMenu so that
 * changing a height here automatically keeps all dependent components in sync.
 */

/** Height of the Content title-bar row (fixed, border included via border-box). */
export const HEADER_TITLE_HEIGHT = 48;

/** Height of the secondary bar strip (content.bar / FormTabBarMenu) */
export const HEADER_BAR_HEIGHT = 32;

/** Height of the MusaTabs navigation row */
export const HEADER_TAB_HEIGHT = 41;

/** z-index for the absolutely-positioned Content header overlay.
 *  Set high enough to stay above form field stacking contexts during scroll. */
export const HEADER_Z_INDEX = 10;
